import React, { FC, useState } from 'react';
import { toast } from 'react-toastify';
import { BaseModal, Button, ToastMessage } from '@cokitchen/cokitchen-components';
import { OrderType } from 'models/order.model';
import { apiService } from 'utils/api';
import { handleApiError } from 'utils/functions';

interface RequestDeliveryFromShipbubbleModalProps {
  show: boolean;
  onClose: () => void;
  order: OrderType;
}

interface RequestDeliveryFromShipbubbleFooterProps {
  loading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const RequestDeliveryFromShipbubbleFooter: FC<RequestDeliveryFromShipbubbleFooterProps> = ({
  onCancel,
  onConfirm,
  loading
}) => (
  <div className='grid grid-cols-2 gap-x-4'>
    <Button small color='primary' variant='outline' className='mx-auto' onClick={onCancel}>
      Cancel
    </Button>
    <Button
      small
      color='primary'
      variant='block'
      className='mx-auto'
      loading={loading}
      onClick={onConfirm}>
      Confirm
    </Button>
  </div>
);

const RequestDeliveryFromShipbubbleModal: FC<RequestDeliveryFromShipbubbleModalProps> = ({
  show,
  onClose,
  order
}) => {
  const [loading, setLoading] = useState(false);
  const requestDeliveryFromShipbubble = async () => {
    try {
      setLoading(true);
      await apiService.post('internal/order/shipbubble/delivery', {
        data: {
          order_code: order.order_code
        },
        isInternal: true,
        baseUrl: process.env.REACT_APP_ORDER_STATS_API_KEY
      });
      toast(
        <ToastMessage type='success' message='Successfully requested delivery from shipbubble' />
      );
      onClose();
    } catch (err) {
      handleApiError(err);
    } finally {
      setLoading(false);
    }
  };
  return (
    <BaseModal
      isOpen={show}
      title='Request Delivery from Shipbubble'
      description={`Are you sure you want to request delivery from Shipbubble for order ${order.order_code}?`}
      onRequestClose={onClose}
      footer={
        <RequestDeliveryFromShipbubbleFooter
          loading={loading}
          onCancel={onClose}
          onConfirm={requestDeliveryFromShipbubble}
        />
      }></BaseModal>
  );
};

export default RequestDeliveryFromShipbubbleModal;
